import { classes } from '../const';

const { isActive } = classes;

export const initShareBtn = el => {
  const $parent = $(el).closest('.js-share-parent');
  const $block = $parent.find('.js-share-block');
  const $closeBtn = $block.find('.js-share-close');

  $(el).click(event => {
    event.preventDefault();
    $block.addClass(isActive);
  });

  $closeBtn.click(event => {
    event.preventDefault();
    $block.removeClass(isActive);
  });

  $(document).click(event => {
    if (!$(event.target).closest('.js-share-block, .js-share-btn').length) {
      $block.removeClass(isActive);
    }
  });
};

const shareBtns = () => {
  const $$shareBtns = $('.js-share-btn');

  $$shareBtns.each((i, el) => {
    initShareBtn(el);
  });
};

export default shareBtns;
